
import dateFormat from 'vux/src/tools/date/format.js'
import Datetime from 'vux/src/components/datetime/index.vue'

export default {
name: "cus-date-time",
components:{Datetime},
data(){
return {
currentValue: '',
};
},
props: {
value: {
type:[String],
default: ''
},
title: {
type:[String],
default:''
},
type:{
type:[String],
default:'date'
},
placeholder:{
type:[String],
default:''
},
disabled:{
type:[Boolean],
default:false
}
},
watch: {
value(val) {
if(val){
if(this.type === 'date'){
this.currentValue = dateFormat(new Date(val),'YYYY-MM-DD');
}else{
this.currentValue = dateFormat(new Date(val),'YYYY-MM-DD HH:mm:ss');
}
}else{
this.currentValue = '';
}
}
},
methods:{
changeEvent(e){
if(e){
this.$emit('input', new Date(e).toISOString());
this.$emit('change',new Date(e).toISOString());
}

}
},
created(){
if(this.value){
if(this.type === 'date'){
this.currentValue = dateFormat(new Date(this.value),'YYYY-MM-DD');
}else{
this.currentValue = dateFormat(new Date(this.value),'YYYY-MM-DD HH:mm:ss');
}
}else{
this.currentValue = '';
}
}
}



// WEBPACK FOOTER //
// ./src/components/cusDateTime.vue